export const withinRange = (index: number, range: Array<number>, overscan: number = 0) => {
    const minIndex = range[0] + overscan;
    const maxIndex = range[1] - overscan;

    return index >= minIndex && index <= maxIndex;
};
